// pipe receiving→eval wave: the PRINTED text of a stored label code — PURE (no React, no DOM).
// Every stored and barcoded code is compact (`INB1042P01`, `SRT1042B01`, `ITM1042P010007`,
// `CMPRSL0012`) so the item label fits the 2.25-inch stock; people read the hyphenated form. This
// mirrors the server's ONE formatter (`services/core-api/src/label_series.rs::display_code`) rule
// for rule: the code is compacted (hyphens/spaces dropped, upper-cased), then one of the four
// minted shapes has its captures joined with `-` behind the prefix (P/B kept on the ordinal). An
// item code always reads its ordinal as two digits. Any other code (legacy 15-digit tags, `P…`
// stickers, serials, bins) is returned unchanged. Display only — never a barcode payload or a
// scan value.

const MINTED_SHAPES: readonly RegExp[] = [
  /^(INB)(\d+)(P\d{2,})$/,
  /^(SRT)(\d+)(B\d{2,})$/,
  /^(ITM)(\d+)(P\d{2})(\d{4,})$/,
  /^(CMP)(RSL|SCR)(\d{4,})$/,
];

/** PURE: the human-readable form of a label code (`ITM1042P010007` → `ITM-1042-P01-0007`); any
 *  code that is not a minted shape comes back exactly as given. */
export function displayCode(code: string): string {
  const compact = code.replace(/[-\s]/g, '').toUpperCase();
  for (const shape of MINTED_SHAPES) {
    const m = shape.exec(compact);
    if (m) return m.slice(1).join('-');
  }
  return code;
}
